import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  CancelCampaignExecutionSuccess,
  CloseCancelCampaignModal,
} from '../actions/cancel-campaign.actions';
import { CancelCampaignModal } from '../actions/search.actions';
import { CampaignSearchResponse } from '../models/campaign-management.model';

export const initialState: CampaignSearchResponse = {
  campaignId: 0,
  campaignExecutionId: 0,
  campaignName: '',
  campaignExecutionTitle: '',
  campaignExecutionDescription: '',
  campaignExecutionDate: '',
  campaignExecutionCountryId: 0,
  campaignExecutionLoyaltySchemaId: 0,
  campaignCommunicationChannel: '',
  campaignExecutionCost: 0,
  controGroupPercentage: 0,
  campaignExecutionLinesCount: 0,
  progressPercentage: '',
  canceled: false,
};

export const CancelCampaignReducer = createReducer(
  initialState,
  on(CancelCampaignModal, (state, { row }) => ({
    ...state,
    campaignId: row.campaignId,
    campaignExecutionId: row.campaignExecutionId,
    campaignName: row.campaignName,
    campaignExecutionTitle: row.campaignExecutionTitle,
    campaignExecutionDescription: row.campaignExecutionDescription,
    campaignExecutionDate: row.campaignExecutionDate,
    campaignExecutionCountryId: row.campaignExecutionCountryId,
    campaignExecutionLoyaltySchemaId: row.campaignExecutionLoyaltySchemaId,
    campaignCommunicationChannel: row.campaignCommunicationChannel,
    campaignExecutionCost: row.campaignExecutionCost,
    controGroupPercentage: row.controGroupPercentage,
    campaignExecutionLinesCount: row.campaignExecutionLinesCount,
    progressPercentage: row.progressPercentage,
    canceled: row.canceled,
  })),
  on(
    ActiveComponentChanged,
    CloseCancelCampaignModal,
    CancelCampaignExecutionSuccess,
    () => initialState,
  ),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
